import head from 'lodash/head';
import kebabCase from 'lodash/kebabCase';
import camelCase from 'lodash/camelCase';
import pick from 'lodash/pick';
import * as flexProperties from './flex-properties.scss';
import * as flexTypes from './flex-types.scss';

const flexPropertiesValues = Object.values(flexProperties).filter(
  v => typeof v === 'string'
);

export const flexPropNames = flexPropertiesValues.map(camelCase);

const filteredFlexTypes = pick(flexTypes, flexPropertiesValues);
const parsedFlexTypes = Object.keys(filteredFlexTypes).reduce(
  (flexTypes, typeKey) => {
    const newKey = camelCase(typeKey);
    const value = filteredFlexTypes[typeKey];
    const newValue = value.split(', ');
    return {
      ...flexTypes,
      [newKey]: newValue
    };
  },
  {}
);

export { parsedFlexTypes as flexTypes };

/*
 * Parse a single flex prop to a single array of classnames according to it.
 * @param {object} property -
 * @return {array} classname list
 */
export function parsePropToClassname(property = {}) {
  const propertyName = head(Object.keys(property));
  const value = property[propertyName];
  const formattedName = kebabCase(propertyName);

  if (typeof value === 'string' || typeof value === 'number') {
    return [`${formattedName}-xs-${value}`];
  } else if (typeof value === 'object') {
    return Object.keys(value).map(breakpoint => {
      return `${formattedName}-${breakpoint}-${value[breakpoint]}`;
    });
  }

  throw new Error('Flex property bad structured!');
}

/*
 * Parse all flex props to a single array of classnames according to it.
 * @param {object} properties - all flex properties in an object
 * @return {array} classname list
 */
export function flexClassnames(properties) {
  return Object.keys(properties).reduce((classnameList, property) => {
    return [
      ...classnameList,
      ...parsePropToClassname({ [property]: properties[property] })
    ];
  }, []);
}

export default flexClassnames;
